const renderProps = {
    mfId: false,
    context: false,
    mfServer: true,
    mfType: true,
    instanceId: true,
    styleDependencies: true,
};
const RENDER_PROPS = Object.keys(renderProps);
const NON_TRANSFERABLE_PROPS = RENDER_PROPS.filter(p => !renderProps[p]);
export function serializeServerProps(props) {
    const propEntries = Object.entries({
        ...props.renderProps,
        ...props.mfProps,
    })
        .filter(([key]) => !NON_TRANSFERABLE_PROPS.includes(key))
        .filter(([, val]) => {
        const isValid = [
            isPrimitive(val),
            Array.isArray(val),
            Object.prototype.toString.call(val) === '[object Object]',
        ].some(valid => valid);
        return isValid;
    })
        .map(([key, val]) => [key, isPrimitive(val) ? val : JSON.stringify(val)]);
    return propEntries;
}
export function deserializeServerProps(params, mfInfo) {
    const propsEntries = Object.entries(params).map(([key, val]) => {
        return [key, deserializeProp(val)];
    });
    const renderProps = Object.fromEntries(propsEntries.filter(([key]) => RENDER_PROPS.includes(key)));
    const mfProps = Object.fromEntries(propsEntries.filter(([key]) => !RENDER_PROPS.includes(key)));
    const { mfId, context } = mfInfo;
    const mfServer = renderProps.mfServer || mfInfo.mfServer;
    const mfType = renderProps.mfType || mfInfo.mfType;
    return {
        renderProps: {
            ...renderProps,
            mfId,
            mfServer,
            mfType,
            context,
        },
        mfProps: {
            ...mfProps,
            mfId,
            mfServer,
            context,
        },
    };
}
function deserializeProp(val) {
    if (!val) {
        return val;
    }
    try {
        val = decodeURIComponent(val);
    }
    catch {
        return undefined;
    }
    const isParsable = [
        val === 'null',
        val === 'true',
        val === 'false',
        /^\d+$/.test(val),
        val.startsWith('{'),
        val.startsWith('['),
    ].some(valid => valid);
    if (!isParsable) {
        return val;
    }
    try {
        return JSON.parse(val);
    }
    catch {
        // ignore
    }
}
function isPrimitive(val) {
    return typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number';
}
//# sourceMappingURL=serializer.js.map